import apiClient from "../core/HttpClient";
import { ExerciseCategory } from "../models";

export default class ExerciseCategoryService{
    url="/ExerciseCategories";
    async getExerciseCategories():Promise<ExerciseCategory[]>{
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });    
    }
    async getExerciseCategory(id: number):Promise<ExerciseCategory>{
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });        
    }

    async addExerciseCategory(data: ExerciseCategory){
        return apiClient.post(this.url, data);
    }

    async updateExerciseCategory(id: number, data: ExerciseCategory) {
        return apiClient.put(`${this.url}/${id}`, data);
    }

    async deleteExerciseCategory(id: number): Promise<void> {
        return apiClient.delete(`${this.url}/${id}`).then((response) => {
            return response.data;
        });
    }
    
    
}